export default {
  default: () => import("/home/runner/work/mfx-framework/mfx-framework/apps/form-builder/layouts/default.vue").then(m => m.default || m)
}